import { render, staticRenderFns } from "./RoleManagement.vue?vue&type=template&id=761a6325&scoped=true"
import script from "./RoleManagement.vue?vue&type=script&lang=ts"
export * from "./RoleManagement.vue?vue&type=script&lang=ts"
import style0 from "./RoleManagement.vue?vue&type=style&index=0&id=761a6325&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761a6325",
  null
  
)

export default component.exports